import { Routes } from '@angular/router';
import { Inicio } from './features/inicio/inicio';
import { Principal } from './features/principal/principal';
import { MiPerfil } from './features/mi-perfil/mi-perfil';
import { InicioPublico } from './features/inicio-publico/inicio-publico';
import { SeleccionRoles } from './features/seleccion-roles/seleccion-roles';
import { Actualizaciones } from './features/actualizaciones/actualizaciones';
import { ModuloPlaceholder } from './features/modulo-placeholder/modulo-placeholder';
import { Patrocinio } from './features/patrocinio/patrocinio';
import { PostulacionDetalle } from './features/postulaciones/components/postulacion-detalle/postulacion-detalle';
import { PostulacionFormulario } from './features/postulaciones/components/postulacion-formulario/postulacion-formulario';
import { Postulaciones } from './features/postulaciones/postulaciones';
import { Invitaciones } from './features/invitaciones/invitaciones';
export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'inicio-publico' },
  { path: 'inicio-publico', component: InicioPublico },
  { path: 'seleccion-roles', component: SeleccionRoles },
  { path: 'principal', component: Principal },
  { path: 'inicio', component: Inicio },
  { path: 'mi-perfil', component: MiPerfil },
  { path: 'actualizaciones', component: Actualizaciones },
  { path: 'patrocinio', component: Patrocinio },
  { path: 'postulaciones/detalle/:id', component: PostulacionDetalle },
  { path: 'postulaciones/formulario/:id', component: PostulacionFormulario },
  { path: 'postulaciones', component: Postulaciones },
  { path: 'invitaciones', component: Invitaciones },
  { path: 'gestion-usuarios', loadComponent: () => import('./features/gestion-usuarios-admin/gestion-usuarios-admin').then((m) => m.GestionUsuariosAdmin) },
  { path: 'formularios-admin', loadComponent: () => import('./features/admin-formularios/admin-formularios').then((m) => m.AdminFormularios) },
  { path: 'monitoreo', loadComponent: () => import('./features/monitoreo/monitoreo').then((m) => m.Monitoreo) },
  { path: 'modulo/:slug', component: ModuloPlaceholder },
  { path: 'mis-postulaciones', redirectTo: 'mi-perfil' },
];
 
 
